import React from "react";
import ClearPaused from "../common/ClearPause";
import { LogRenderContext } from "../LogRenderer";

const CampaignClearPaused = () => {
  const { log } = React.useContext(LogRenderContext);
  const { campaign } = log.dataSnapshot;
  const {
    campaign: { updatedBy, updatedAt },
  } = log.changedFields;
  const { name } = campaign;
  return <ClearPaused name={name} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default CampaignClearPaused;
